module.exports = __webpack_public_path__ + "43d5c718339efeb1177aff722d72669d.woff2";